<template>
  <el-drawer title="发起审批" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthSpecial">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="仓库名称：" prop="warehouseId">
        <el-select v-model="addForm.warehouseId" filterable clearable value-key="warehouseId" placeholder="选择仓库名称" style="width: 100%">
          <el-option
            v-for="item in indexThis.warehouseListArr"
            :key="item.warehouseId"
            :label="item.warehouseName"
            :value="{ warehouseId: item.warehouseId, warehouseName: item.warehouseName }"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="领用用途：" prop="reason">
        <el-input v-angle="addForm.reason" v-model="addForm.reason" placeholder="填写领用用途" :rows="4" maxlength="70" type="textarea" show-word-limit clearable />
      </el-form-item>
      <template>
        <div class="header flex align-center justify-between mb-16">
          <div class="title">物资领用单</div>
          <div class="right flex align-center">
            <div @click="selectMaterials">选择物资</div>
            <!-- <div @click="importMaterials">批量导入物资</div> -->
          </div>
        </div>
        <template v-if="addForm.selectedMaterialList && addForm.selectedMaterialList.length">
          <ETips padding="13px 16px" background="#edf7ff" color="#31a8ff" :marginBottom="16" text="系统将根据物资分类拆分为多个物资领用单。" />

          <div v-for="(item, index) in addForm.selectedMaterialList" :key="index" class="box mb-16">
            <div class="liHeader mb-16 flex align-center justify-between">
              <div>物资领用单{{ index + 1 }}</div>
              <div>物资分类：{{ item.materialCategoryName }}</div>
            </div>
            <el-table ref="multipleTable" row-key="id" :data="item.materialList" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
              <el-table-column label="物资名称" align="center">
                <template slot-scope="scope">
                  {{ scope.row.label || '-' }}
                </template>
              </el-table-column>
              <el-table-column label="*数量" align="center">
                <template slot-scope="{ row, $index }">
                  <el-form-item :prop="`selectedMaterialList.${index}.materialList.${$index}.number`" :rules="rules.number" class="inner-form-item">
                    <el-input v-number="row.number" v-model="row.number" placeholder="请填写数量" clearable style="width: 90%" />
                    <span style="margin-left: 8px">{{ dictType('materialUnit', row.materialUnit) }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center" width="80px">
                <template slot-scope="{ row, $index }">
                  <div class="delete" @click="deleteItem(index, $index)">删除</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </template>
    </el-form>
    <FixedTwoButton activeClass="widthSpecial">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
    <MaterialTree
      ref="MaterialTree"
      :queryData="{
        warehouseId: addForm.warehouseId.warehouseId,
      }"
      :selectedData="selectedData"
    />
    <UploadFile
      ref="UploadFile"
      level="物资"
      downLoadApiUrl="dataExchange/materialDataImportXLTmpl"
      uploadApiUrl="oa/excelDataImportEcho"
      :fileTypeName="118"
      @handlerSuccess="handlerSuccess"
    />
  </el-drawer>
</template>

<script>
import { getToken } from '@/utils/auth'
import { submitFlowMaterialApply } from '@/api/workflow'
import formatData from '@/utils/formatRequestData'
import MaterialTree from './MaterialTree'

export default {
  inject: ['indexThis'],
  components: { MaterialTree },
  provide() {
    return {
      addThis: this,
    }
  },
  data() {
    return {
      drawer: false,
      addForm: {
        warehouseId: '',
        warehouseName: '',
        reason: '',
        selectedMaterialList: [],
      },
      rules: {
        warehouseId: [{ required: true, message: '仓库名称不能为空', trigger: 'change' }],
        reason: [{ required: true, message: '领用用途不能为空', trigger: 'change' }],
        number: [{ required: true, message: '物资数量不能为空', trigger: 'change' }],
      },
      selectedData: [],
    }
  },
  watch: {
    drawer(val) {
      if (val) {
      }
    },
  },
  computed: {
    token() {
      return getToken()
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const format = formatData(this.addForm)
      const { data: res } = await submitFlowMaterialApply({
        flowMaterialItems: this.addForm.selectedMaterialList.flatMap(item =>
          item.materialList.map(ele => {
            return {
              materialName: ele.label,
              materialId: ele.id,
              requestNumber: ele.number,
              materialCategoryId: ele.materialCategoryId,
            }
          })
        ),
        flowMaterialDetail: {
          warehouseId: format.warehouseId,
          warehouseName: format.warehouseName,
          applyReason: format.reason,
        },
      })

      if (!res) return this.$message.error('发起失败')
      this.$message.success('发起成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    // 删除
    deleteItem(index, itemIndex) {
      const targetId = this.addForm.selectedMaterialList[index].materialList[itemIndex].id
      this.selectedData = this.selectedData.filter(item => item.id !== targetId)
      this.addForm.selectedMaterialList[index].materialList.splice(itemIndex, 1)
      if (!this.addForm.selectedMaterialList[index].materialList.length) {
        this.addForm.selectedMaterialList.splice(index, 1)
      }
    },

    // 批量导入物资
    importMaterials() {},

    // 选择物资
    selectMaterials() {
      if (!this.addForm.warehouseId) return this.$message.error('请选择存放仓库')
      this.$refs.MaterialTree.drawer = true
    },

    // 批量导入
    async batchImport() {
      this.$refs.UploadFile.dialogVisible = true
    },
    // 导入成功
    handlerSuccess() {},
  },
}
</script>

<style lang="less" scoped>
.inner-form-item {
  margin-bottom: 0px !important;
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
  }
}
.box {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px;
  .liHeader {
    font-size: 16px;
    font-weight: bold;
    color: #3d3d3d;
  }
  .delete {
    font-size: 14px;
    color: #fa0000;
    cursor: pointer;
  }
}
.header {
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3d3d3d;
  }
  .right {
    div {
      cursor: pointer;
      font-size: 14px;
      color: #31a8ff;
      &:first-child {
        margin-right: 16px;
      }
    }
  }
}
.mb-16 {
  margin-bottom: 16px;
}
</style>
